// extracted by mini-css-extract-plugin
module.exports = {"PageHolder":"RequestDeliver_PageHolder__3awEk","TabsTitle":"RequestDeliver_TabsTitle__gsL44","normal":"RequestDeliver_normal__2pqZw","checked":"RequestDeliver_checked__3hAa4"};